import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardFilled = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#1071ee" ref={ref} {...props}><path d="M0 0h24v24H0z" fill="none" /><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" /></svg>;
const ForwardRef = forwardRef(SvgDashboardFilled);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/_Connect_service_dev_uat-release/src/icons/dashboardFilled.svg?url";
export default __svgUrl;
